import { Button, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useAuth0 } from "@auth0/auth0-react";

import { ErrorCard, Header, Wrapper } from "src/components";
import tokens from "src/shared/theme/tokens";
import { safeLogout } from "src/shared/utilities/fullStorySession";

/**
 * Shown to residents whose leases are all on dispositioned (deactivated)
 * properties. Reached via a window redirect from the store middleware when the
 * API returns 403 { code: "PROPERTY_INACTIVE" }. Mirrors the 401/404 error
 * screens (Wrapper + Header + centered ErrorCard).
 */
export const PropertyInactiveScreenContainer = () => {
  const { logout, isAuthenticated, isLoading } = useAuth0();

  return (
    <Wrapper>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "calc(var(--vh, 1vh) * 100)",
          background: tokens.colors.pageBg,
        }}
      >
        <Header isBackButtonVisible={false} />
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            paddingX: { xs: 6, sm: 10 },
            paddingBottom: 8,
            textAlign: "center",
          }}
        >
          <ErrorCard>
            <Typography
              variant="h3Bold"
              component={"p"}
              color={tokens.colors.primary}
              textAlign={"center"}
              marginBottom={4}
            >
              {"This community is no longer on TenantPort"}
            </Typography>
            <Typography
              variant="h3"
              component={"p"}
              color={tokens.colors.inkSecondary}
              textAlign={"center"}
              marginBottom={6}
            >
              {
                "Your community is no longer managed through TenantPort, so portal access has been closed. If you believe this is a mistake, please contact your property team."
              }
            </Typography>
            <Button
              variant="contained"
              color="primary"
              type="button"
              sx={{ minWidth: "120px", marginX: "auto" }}
              onClick={() => safeLogout(logout)}
            >
              {isAuthenticated && !isLoading && "Log Out"}
              {!isAuthenticated && !isLoading && "Home"}
            </Button>
          </ErrorCard>
        </Box>
      </Box>
    </Wrapper>
  );
};
